'use client'

import Button from "@/components/button/Button"
import Field from "@/components/form/Field"
import FormCell from "@/components/form/FieldCell"
import FormCells from "@/components/form/FieldCells"
import Form from "@/components/form/Form"
import ApiUtils, { logABEvent } from "@/utils/ApiUtils"
import { DM_FIELDS } from "@dealermesh/react"
import { useState, useEffect } from "react"
import loggingService from '@/services/logs/LoggingService';
import { strings } from "@/utils/I18n"
import useEventListener, { emitEvent } from "@/components/plugins/EventListener"
import GoogleLoginButton from "@/components/plugins/GoogleLoginButton"

export default function LeadForm(props) {
  
  const site = props.site

  const ctx = props.ctx || site.page_name
  const vehicle = props.vehicle || props.inventory

  const [customerId, setCustomerId] = useState(props.site?.session?.lead?.customer_id)
  const [userId, setUserId] = useState()
  const [clientLoaded,setClientLoaded] = useState(false)
  const [isZipFound, setIsZipFound] = useState(false)
  const [dealers, setDealers] = useState([]);
  const [dealer, setDealer] = useState(props.dealer)
  const [delivery, setDelivery] = useState({})
  const [dealersSalt,setDealersSalt] = useState(1)
  
  const [form,setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    textEnabled: false,
    zip: site.session?.vehicles?.location?.zip?.split("-")[0]
  })
  const [errors,setErrors] = useState([])

  useEventListener("third_party_signin", event => {
    if (!props.ctx || event.detail.ctx == props.ctx) {
      const user = event.detail
      let data = Object.assign({}, form)
      data["firstName"] = user.first_name
      data["lastName"] = user.last_name
      data["email"] = user.email
      data["ext_id"] = user.account_id
      data["platform"] = user.platform
      setForm(data)
      onSubmit(null, data)
    }
  })

  const isZipCodeValid = (zipCode) => {
    const us_regex = /^\d{5}$/;
    return us_regex.test(zipCode)
  }

  const getClosestDealerLocations = (zip) => {
    // Here, we won't hit the "find_closest" endpoint if the page is 'VDP' and it's a 'NEW' car.
    if (zip && isZipCodeValid(zip) && (!(site.page_name === 'vdp' && vehicle && vehicle.condition === 1) || props.pickup)) {
      setIsZipFound(false)
      setDealersSalt(new Date().getTime())
      if (props.pickup && vehicle && vehicle.condition === 1) {
        const location = props.site?.session?.vehicles?.location
        ApiUtils.getRequest("/api/dealer/make/" + vehicle.make_name + "?lat=" + location.lat + "&lon=" + location.lon)
        .then(data => {
          if (data && data.length) {
            setIsZipFound(true)
            let dealerList = []
            data.forEach((dealer) => {
              dealer.id = dealer.uqid
              dealer.label = dealer.name + " - " + dealer.distance + " mi"
              dealerList.push(dealer)
            });
            setDealers(dealerList);
            setDealersSalt(new Date().getTime())
          }
        })
        .catch(error => {
          loggingService.error(error)
        });
      } else {
        ApiUtils.getRequest(`/console/api/dealers/find_closest?zip=${zip}`)
        .then(data => {
          if (data && data.length) {
            setIsZipFound(true)
            let dealerList = []
            data.forEach((dealer) => {
              dealer.id = dealer.uqid
              dealer.label = dealer.name + " - " + dealer.distance + " mi"
              dealerList.push(dealer)
            });
            setDealers(dealerList);
            setDealersSalt(new Date().getTime())
          }
        })
        .catch(error => {
          loggingService.error(error)
        });
      }
    }
  }

  useEventListener("lead_sync", event => {
    loadLead(event.detail?.customer_id)
  })

  useEffect(() => {
    setClientLoaded(true)
    if (!customerId) emitEvent("lead_sync_request")
    if (!form.firstName) {
      ApiUtils.getRequest("/console/api/users/me")
      .then(data => {
        const user = data.user
        if (user) {
          let lead = Object.assign({}, form)
          if (!lead["firstName"]) {
            lead["firstName"] = user.first_name
            lead["lastName"] = user.last_name
            lead["email"] = user.email
            setForm(lead)
            setUserId(user.user_id)
          }
        }
      })
      .catch(err => {
      })
    }
  }, [])

  useEffect(() => {
    if (customerId) {
      loadLead(customerId)
    }
    if (vehicle && vehicle.dealer) {
      const d = Object.assign(vehicle.dealer, { uqid: vehicle.dealer.dealer_id, id: vehicle.dealer.dealer_id, name: vehicle.dealer.name || vehicle.dealer.dealer_name })
      setDealers([d])
      setDealer(d)
      checkDelivery(d)
    }
    if (site.page_name === 'vdp' && vehicle && vehicle.condition === 1 && !props.pickup) {
      const did = vehicle.dealer.dealer_id;
      setIsZipFound(true)
      setDealersSalt(new Date().getTime())
    }
    if (props.abData) {
      logABEvent(site, "form", "view", "lead_form_" + ctx, props.abData?.keyword, props.abData || {}, vehicle)
    }
  }, []);

  const loadLead = (customerId) => {
    ApiUtils.getRequest(`/console/api/leads/${customerId}`)
    .then(data => {
      setForm({
        customer_id: data.customer.customer_id,
        firstName: data.customer.first_name,
        lastName: data.customer.last_name,
        email: data.customer.email,
        phone: data.customer.phone_1,
        zip: data.customer.zip,
      })
      if (data.customer.dealer && !data.customer.dealer.uqid) {
        data.customer.dealer.uqid = data.customer.dealer.dealer_id
      }
      setDealer(data.customer.dealer || dealer)
    })
    .catch(error => {
    });
  }

  const handleDealerChange = (dealerId) => {
    const dealer = dealers.filter(d => d.uqid == dealerId)[0]
    setDealer(dealer)
    checkDelivery(dealer)
  }

  useEffect(() => {
    // if ((site.page_name == 'vdp' && vehicle && vehicle.condition && vehicle.condition != 1) || (['home', 'srp', 'trade'].includes(site.page_name) && props.isLeadFormOpened) || props.pickup) {
    if ((vehicle && vehicle.condition && vehicle.condition != 1) || props.isLeadFormOpened || props.pickup) {
      const timeoutId = setTimeout(() => {
        getClosestDealerLocations(form.zip)
      }, 2000);

      return () => {
        clearTimeout(timeoutId); // Clear the timeout on component unmount or when form.zip changes
      };
    }

  }, [form.zip, props.isLeadFormOpened])
  
  const onFieldChange = (name, value) => {
    let data = Object.assign({}, form)
    data[name] = value
    setForm(data)
  }

  const validateEmail = (email) => {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  
  const isValid = (check) => {
    let errorList = []
    if (!form.firstName) {
      errorList.push({ field: "firstName", message: "First name is required." })
    }
    if (!form.lastName) {
      errorList.push({ field: "lastName", message: "Last name is required." })
    }
    if (!form.email) {
      errorList.push({ field: "email", message: "Email is required." })
    }
    if (!validateEmail(form.email)) {
      errorList.push({ field: "email", message: "Invalid email address." })
    }
    if (!form.zip) {
      errorList.push({ field: "zip", message: "Zip is required." })
    }
    if (!isZipCodeValid(form.zip) || !isZipFound) {
      errorList.push({ field: "zip", message: "Please enter a valid zip" })
    }
    if (!check) {
      setErrors(errorList)
    }
    if (!dealer) {
      return false
    }
    return errorList.length == 0
  }
  
  const onSubmit = (e, params) => {
    if (e) e.preventDefault()
    let payload = Object.assign(props.refData || {}, { site: props.site.site_id }, {
      customer: {
        ext_id: params?.ext_id,
        platform: params?.platform,
        first_name: params?.firstName || form.firstName,
        last_name: params?.lastName || form.lastName,
        email: params?.email || form.email,
        phone: params?.phone || form.phone,
        zip: params?.zip || form.zip,
      }
    })
    if (form.comments) {
      payload.lead_comments = "Customer Comments: " + form.comments
    }
    if (delivery && delivery.available) {
      payload.vehicle_comments = delivery.message
    } else if (props.pickup) {
      payload.vehicle_comments = "Customer would like to pickup the car from " + dealer.name + "."
    }

    if (dealer?.uqid) {
      payload.dealer_id = dealer.uqid
    }
    if (!dealer && props.dealer) {
      payload.dealer_id = props.dealer.uqid
    }

    if (props.vehicle) {
      payload.vehicle = {
        id: props.vehicle.id,
        vin: props.vehicle.vin,
        name: props.vehicle.full_name
      }
    }
    
    ApiUtils.postRequest("/console/api/leads/submit", payload)
    .then(data => {
      if (data.customer_id) {
        if (!props.site.session) props.site.session = {}
        props.site.session.lead = data
        ApiUtils.postRequest("/api/visitor/track", { 
          payload: { 
            lead: { 
              customer_id: data.customer_id,
            }
          } 
        })
        if (props.onSubmit) props.onSubmit(data)
      }
    })
  }

  const checkDelivery = async (d) => {
    if (props.pickup) {
      setDelivery({})
    } else {
      const location = props.site?.session?.vehicles?.location
      ApiUtils.getRequest("/api/dealer/delivery?id=" + d.id + "&lat=" + location.lat + "&lon=" + location.lon)
      .then(data => {
        setDelivery(data)
      })
    }
  }

  if (!clientLoaded) return <></>
  
  return <Form key={customerId || userId || '1'} id="lead_form" name="Lead Form" onSubmit={e => onSubmit(e)}>
    <section key={form.customer_id || '1'}>
      <FormCells>
        { props.site.api_keys?.g_oauth_client_id && !ApiUtils.authToken() &&
        <FormCell>
          <GoogleLoginButton {...props}></GoogleLoginButton>
        </FormCell>
        }
        { props.site.api_keys?.g_oauth_client_id && !ApiUtils.authToken() &&
        <FormCell>
          <span className="text-align-center">- OR -</span>
        </FormCell>
        }
        <FormCell size={props.size}>
          <Field type="text" name={DM_FIELDS.CONTACT_FIRST_NAME} placeholder="First Name*" value={form.firstName} onChange={value => onFieldChange("firstName", value)}></Field>
        </FormCell>
        <FormCell size={props.size}>
          <Field type="text" name={DM_FIELDS.CONTACT_LAST_NAME} placeholder="Last Name*" value={form.lastName} onChange={value => onFieldChange("lastName", value)}></Field>
        </FormCell>
        <FormCell size={props.size}>
          <Field type="text" name={DM_FIELDS.CONTACT_EMAIL} placeholder="Email*" value={form.email} onChange={value => onFieldChange("email", value)}></Field>
        </FormCell>
        <FormCell size={props.size}>
          <Field type="text" name={DM_FIELDS.CONTACT_MOBILE_PHONE} placeholder="Phone (optional)" value={form.phone} onChange={value => onFieldChange("phone", value)}></Field>
        </FormCell>
        <FormCell size={props.size}>
          <Field type="text" name={DM_FIELDS.CONTACT_ZIP} placeholder="Zip Code*" value={form.zip} onChange={value => onFieldChange("zip", value)}></Field>
        </FormCell>
        { (site.page_name !== 'vdp' || vehicle?.condition !== 1 || props.pickup) &&
        <FormCell key={dealersSalt} size={props.size}>
          <Field name="dealersList" value={dealer?.id || ''} type="select" options={dealers} placeholder={ props.pickup ? strings(props.site)['leads_pickupDealerPlaceholder'] : strings(props.site)['leads_selectDealerPlaceholder'] } onChange={e => handleDealerChange(e)}></Field>
        </FormCell>
        }
        { dealer &&
        <FormCell>
          <div className="flex-row flex-with-gap">
            <div className="flex-stretch">
              <span className="text-xs">{ props.pickup ? strings(props.site)['leads_pickupDealerHeader'] : dealers.length > 1 ? strings(props.site)['leads_selectedDealerHeader'] + ':' : 'Dealership:' }<br/></span>
              <span><b>{dealer.name || dealer.dealer_name}</b>{dealer.city ? ", " + dealer.city + ", " + dealer.state : ""}</span>
              { delivery?.available && delivery.free &&
              <span><br/>{ strings(props.site)['leads_talkToDealerShipping'] } <b className="text-secondary" title={ delivery.message }>{ strings(props.site)['leads_talkToDealerFreeShipping'] }</b></span>
              }
              { delivery?.available && !delivery.free &&
              <span><br/>{ strings(props.site)['leads_talkToDealerShipping'] } <b className="text-secondary" title={ delivery.message }>{ strings(props.site)['leads_talkToDealerPaidShipping'] }</b></span>
              }
            </div>
            <a className='flex-col' target="_blank" aria-label={dealer.name || dealer.dealer_name} href={'https://maps.google.com?q=' + (dealer.name || dealer.dealer_name) + "," + dealer.city + "," + dealer.state + "&ll=" + dealer.location.lat + ',' + dealer.location.lon}>
              <img src={site.page?.location?.map_icon} style={{width:'auto',height:'44px'}}></img>
            </a>
          </div>
        </FormCell>
        }
        { (site.lead?.show_comments) &&
        <FormCell>
          <Field name="comments" value={form.comments || ''} type="textarea" placeholder={ 'Enter your comments' } onChange={value => onFieldChange('comments', value)}></Field>
        </FormCell>
        }
        <FormCell size={site.lead?.show_comments ? '' : props.size}>
          <Button type="submit" theme={['secondary']} label={ props.submitLabel || strings(props.site)['leads_defaultButtonLabel'] || "Send to Dealer" } disabled={!isValid(true)}></Button>
        </FormCell>
      </FormCells>
    </section>
  </Form>
  
}
